import { PrivilegeEnum as o } from "@hprofits/shared/auth";
import { ocPrivate as m } from "../common/auth/procedure-builders.js";
import "../swagger/security.js";
import { SwaggerTags as r } from "../swagger/tags.js";
import { DomainsQuerySchema as i, DomainsResponseSchema as t } from "./schemas.js";
const d = {
  domains: {
    /**
     * List active domains with impressions count.
     * Returns only domains with status=OK and deleted_at IS NULL.
     * Sorted by impressions descending.
     */
    findAll: m([o.ReadAdvert]).route({
      method: "GET",
      path: "/domains",
      summary: "List active domains with impressions",
      tags: [r.DOMAINS.name]
    }).input(i).output(t).errors({})
  }
};
export {
  d as domainsContract
};
//# sourceMappingURL=contract.js.map
